import aTagRenderer from './Renderers/aTagRenderer';
import pTagRenderer from './Renderers/pTagRenderer';
import h1TagRenderer from './Renderers/h1TagRenderer';

export default {
  a: aTagRenderer,
  p: pTagRenderer,
  h1: h1TagRenderer
};
